// extracted by mini-css-extract-plugin
var _1 = "MultiSelect-moduleMultiSelect__EEZWk";
export { _1 as "MultiSelect" }
